import "../styles/newsstories.css";
import Footer from "../components/Footer";

const NewsStoryTwo = () => {


  return (
    <>
      <div className="">
        <div className="newsStoryHeaderLogo">
            <a href="/?mercedes-client-information-hub" target="_blank" rel="noopener noreferrer">
              <img
                src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/logo-new.png"
                alt="Mercedes Legal Logo"
              />
            </a>
          </div>
        <div className="newsStoryHeader">
          <div className="veryLargeText boldText">The Emissions Scandal – The Journey So Far</div>
          <div className="regularText greenText">August 16, 2024</div>
        </div>
      </div>
      <div className="whiteBackground newsCopyConatiner">
            <div className="newsCopy">  
              <img className="newsStoryImage mb20" src="https://mydieselclaim.com/wp-content/uploads/2025/01/AdobeStock_314734079-768x454-1.jpeg" alt="Mercedes Legal Logo" />
              <div className="italicText">Where it all began…</div>
              <div>Our work to provide justice to the millions of people in the UK who were impacted by the Dieselgate emissions scandal started all the way back in 2015. Once Dieselgate broke, we began our landmark litigation against Volkswagen – part of the first emissions claim against Volkswagen (The VW1 NOx Emissions Claim).</div>
              <div>You may remember the headlines at the time when the United States Environmental Protection Agency (EPA) revealed that Volkswagen had been cheating emissions tests, using what’s called ‘defeat devices’ to manipulate the emissions control technology on their diesel vehicles.</div>
              <div>This meant that more than 11 million vehicles were emitting unsafe levels of polluting emissions, including oxides of nitrogen (NOx) and particulate matter (PM).</div>
              <div className="boldText">What was the impact of Dieselgate?</div>
              <div>The environmental impact of car companies choosing to cheat emissions tests was huge. For years, high levels of nitrogen oxides (NOx), sometimes up to 35 times the legal limit, were being emitted undetected into the atmosphere.</div>
              <div>Too much NOx in the atmosphere has proven to be deadly – polluting the air we breathe and killing an estimated 23,500 people every <span className="greenText">year</span>.</div>
              <div className="boldText">What does the legal process look like for your claim?</div>
              <div>Taking on the world’s biggest car companies on this scale is a complex and time-intensive process. That’s why we have teams of specialist lawyers working on your cases, ensuring every detail is thoroughly covered.</div>
              <div>This is just some of the work that goes into preparing and winning your case:</div>
              <ul className="pl20">
                <li>Initiating a claim in the appropriate Court</li>
                <li>Checking that our clients meet the eligibility criteria to claim</li>
                <li>Compiling and checking the documents provided by clients</li>
                <li>Corresponding with the Defendants’ lawyers</li>
                <li>Issuing and serving claims in Court and on the Defendants</li>
                <li>Developing a case strategy</li>
                <li>Attending hearings</li>
                <li>Awaiting decisions by the Courts</li>
              </ul>
              <div>Following our successful £193 million settlement with VW in 2022, Pogust Goodhead has been at the forefront of taking on other car companies accused of doing the same thing. Right now, we’re the lead solicitors for 12 group claims against car companies on behalf of millions of British drivers, working hard to achieve the same outcome for you.</div>
              <div>While many claimant firms are involved in these diesel claims, being the lead solicitors means that we have direct involvement in the overall steerage and strategies of the litigation. As we have the most Dieselgate clients bringing claims across the claimant law firms, we are able to lead and develop best practices based on your feedback to shape our approach and make sure our clients feel informed and supported every step of the way.</div>
            </div>
          </div>
      <Footer />
    </>
  );
};

export default NewsStoryTwo;
